import { Component,OnInit } from '@angular/core';
import { ENVIRONMENTS, RECAPTCHA_SITE_KEY_PROD, RECAPTCHA_SITE_KEY_TEST } from '../../constants/upplm.constants';
import { ConfigurationService } from '../../services/upplm.configuration.service';
@Component({
    selector: 'app-root',
    template: require('./app.component.html')
})
export class UpsUpplmComponent implements OnInit{
    onActivate(event) {
        window.scroll(0, 0);
    }

    siteKey: string = RECAPTCHA_SITE_KEY_TEST;

    constructor(private _configurationService: ConfigurationService) { }

    ngOnInit() {
        if (this._configurationService.appSettings.environment === ENVIRONMENTS.MAHWAH || this._configurationService.appSettings.environment === ENVIRONMENTS.WINDWARD) {
            this.siteKey = RECAPTCHA_SITE_KEY_PROD;
        }
        this.loadScript(`https://www.google.com/recaptcha/enterprise.js?render=${this.siteKey}`);
    } 

    public loadScript(url: string) {
        const body = <HTMLDivElement> document.body;
        const script = document.createElement('script');
        script.innerHTML = '';
        script.src = url;
        script.async = false;
        script.defer = true;
        body.appendChild(script);
      }
    

}
